define.alias("ember-focus-trap/modifiers/focus-trap.js", "media/modifiers/focus-trap");